//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START OF IMPORTS////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

import React, { Component } from "react";
import styled from "styled-components";
import firebase from "firebase";
import { Grommet, Box, Heading } from "grommet";
import {
  Home,
  Catalog,
  Organization,
  Run,
  Schedules,
  Schedule,
  UserPolice,
  Group,
  Optimize,
  Tag,
  Accessibility,
  Alert,
  Cafeteria,
} from "grommet-icons";
import { Query } from "react-apollo";

/////////////////////////Custome Components/////////////////////////////////////////////////////
import TimelineView from "./components/TimeLineView";
import GuardOverview from "./components/GuardOverview";
import StationView from "./components/StationView";
import PatrolsTable from "./components/PatrolsTable";
import RouteInstanceTables from "./components/RouteInstanceTables";
import RoamTable from "./components/RoamTable";
import BreaksView from "./components/BreaksView";
import LogbookTable from "./components/LogbookTable";
import theme from "./theme";
import IncidentsView from "./components/IncidentsView";
import { getGoogleMaps } from "./utils/Utils";
import TaskDetail from "./components/TaskDetail";
import TaskOverViewTable from "./components/taskOverview/TaskOverviewTable";
import DelayedTaskTable from "./components/delayedTasks/DelayedTasksTable";
/////////////////////////Custome Components/////////////////////////////////////////////////////

const ApolloClient = require("apollo-boost").ApolloClient;
const gql = require("apollo-boost").gql;
const createHttpLink = require("apollo-link-http").createHttpLink;
const InMemoryCache = require("apollo-cache-inmemory").InMemoryCache;

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF IMPORTS//////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START  OF CLIENT CONFIG/////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

var firebaseConfig = {
  apiKey: "AIzaSyAdYYpjrVJtX0kAcsYhXap2Hit2RCSHo00",
  authDomain: "ioloc-dev.firebaseapp.com",
  databaseURL:
    "https://ioloc-dev-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ioloc-dev",
  storageBucket: "ioloc-dev.appspot.com",
  messagingSenderId: "884450819364",
  appId: "1:884450819364:web:439e8a18a23ef0c76307b1",
  measurementId: "G-XC2TP3QR6G",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const MainContainer = styled.div`
  //height: calc(100vh - 50px);
  height: 100%;
  overflow: hidden;
  display: grid;
  //grid-template-columns: 100%;

  background-color: #051932;
  color: #eee;
`;

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF CLIENT CONFIG////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START OF QUERY//////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

const SHIFT_QUERY = gql`
  query MyQuery(
    $id: bigint!
    $date: timestamptz
    $exclId: bigint
    $exclId2: bigint
  ) {
    Shift(where: { Id: { _eq: $id } }) {
      Building {
        Id
        FloorOverlays {
          CenterLat
          CenterLng
          D_diff
          FloorNumber
          Id
          ImageUrl
          Rot
          k_diff
        }
        Logbooks(where: { Active: { _eq: true } }) {
          LogbookInstances(
            where: {
              startTime: { _gt: $date }
              _or: { endTime: { _gt: $date } }
            }
          ) {
            Building_Gaurd {
              Gaurd {
                GaurdFirstName
              }
            }
            complete
            endTime
            id
            startTime
            timeType
            LogBookItemInstances {
              description
              fieldName
              id
              logbookInstanceId
              logbookItemId
              type
              LogbookItem {
                inputFieldType
              }
            }
          }
          logbookTimeType
          logbookTitle
          logbookType
          LogbookItems {
            title
          }
        }
      }
      Description
      EndDateTime
      Id
      StartDateTime
      buildingId
      Shift_Gaurds(
        where: {
          GaurdId: { _neq: $exclId }
          _and: { GaurdId: { _neq: $exclId2 } }
        }
      ) {
        Breaks {
          EndDateTime
          Id
          POIId
          ShiftGaurdId
          StartDateTime
          Type
          IoLocLocations {
            Latitude
            Longitude
          }
        }
        DeviceID
        Gaurd {
          GaurdFirstName
          Id
          Url
        }
        Id
        Incidents {
          Description
          EndDateTime
          Id
          ImageUrl
          Lat
          Long
          ShiftGaurdId
          StartDateTime
          Title
        }
        RoleInstances(order_by: { timeStart: asc }) {
          DateTimeEnd
          timeStart
          Id
          PatrolPointsReached
          RoleId
          RouteInstances(order_by: { StartTimeDate: asc }) {
            EndTimeDate
            RoleInstanceId
            isOnTime
            distance
            StartTimeDate
            Route {
              Distance
              IdealTimeSeconds
              pOIByStartpointid {
                Description
              }
              POI {
                Description
              }
            }
          }
          Role {
            Id
            Lat
            Lng
            Title
            Type
          }
          IoLocLocations(order_by: { DateTime: asc }) {
            DateTime
            Floor
            Latitude
            Longitude
            Shift_Gaurd {
              Gaurd {
                GaurdFirstName
              }
            }
            RoleInstanceId
          }
          deviceId
        }
        RejectedTaskInstances {
          Id
          ShiftGaurdId
          dateTime
          taskId
          Task {
            Name
          }
        }
        TaskInstances {
          EndDateTime
          Id
          StartDateTime
          Task {
            Name
            IdealCompletionTime
          }
          SubTaskInstances {
            Id
            EndDateTime
            IsOnTime
            StartDateTime
            SubTask {
              SubTaskType
              Description
              IdealCompletionTime
              TaskItems {
                TaskItemType
                Title
                Checklists {
                  TaskItemId
                  Title
                  Id
                }
                FormItems {
                  TaskItemId
                  Title
                  Id
                }
                TakePhotoTaskItems {
                  Id
                  Description
                  Title
                  TaskItemId
                }
              }
            }
            ChecklistInstances {
              IsComplete
              Checklist {
                Title
                Id
              }
            }
            FormItemInstances {
              Input
              Id
              FormItemId
            }
            TakePhotoInstances {
              Id
              ShiftGuardId
              SubTaskId
              SubTaskInstanceId
              TakePhotoTaskItemId
              TaskItemId
              URL
            }
            WaypointInstances {
              DateTimeEnd
              DateTimeStart
              Id
              StartLat
              StartLng
              SubTaskInstanceId
              WaypointId
              Waypoint {
                Lat
                Long
                Message
                Name
              }
            }
          }
          Shift_Gaurd {
            Gaurd {
              Id
              GaurdFirstName
            }
          }
          IoLocLocations {
            Longitude
            Latitude
            Floor
          }
          completed
        }
        TotalDistanceWalked
      }
    }
  }
`;

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF QUERY////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START MAIN COMPONENT DEFINITION/////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

export class Report extends Component {
  state = {
    shiftData: {
      shiftId: null,
    },
    shiftDataToggle: false,
    floorOverlays: [],
  };

  getTimeDifferenceNumber = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = (end.getTime() - start.getTime()) / 1000;

    return difference;
  };

  componentWillMount = async () => {
    console.log("componentWillMount");
  };

  componentDidMount = () => {
    let googleMapPromise = getGoogleMaps();
    if (!window.google) {
      //console.log("!window.google");
      Promise.all([googleMapPromise]).then((values) => {
        // eslint-disable-next-line
        let google = values[0];
        //this.getShiftData();
        //console.log(values);
      });
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////START  OF RENDER FUNCTION///////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    const floorOverlays = this.props.shiftData.Building.FloorOverlays;
    console.log("Output: : Report -> render -> floorOverlays", floorOverlays);
    const getPrettyDateString = (dateString) => {
      const firstArray = dateString.split("T");
      const timeString = firstArray[1];
      const secondArray = timeString.split("+");
      return secondArray[0];
    };

    const shiftData = this.props.shiftData;
    console.log("Output: : Report -> render -> shiftData", shiftData);

    let tabBlock = null;

    const smallList = this.state.smallList;

    const DateTimeStart = shiftData.StartDateTime;

    const DateTimeEnd = shiftData.EndDateTime;

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////STARRT OF PARTS OF REPORT//////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////

    const timelineBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Schedule></Schedule>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="timeline"
            size="small"
            level="3"
            textAlign="center"
          >
            Timeline
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>

        <TimelineView
          shiftId={this.props.shiftId}
          runningLocally={this.props.runningLocally}
        ></TimelineView>
      </Box>
    );

    const overViewBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Optimize></Optimize>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="overviews"
            size="small"
            level="3"
            textAlign="center"
          >
            Individual Guard Performance
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box>
          {shiftData.Shift_Gaurds.map((shiftGuard, index) => {
            let dataPoints = [];
            let patrolDataPoints = [];
            let roamDataPoints = [];
            let stationDataPoints = [];
            let patrolTime = 0;
            let roamTime = 0;
            let stationTime = 0;
            let roleIds = [];
            let roleData = {};
            shiftGuard.RoleInstances.forEach((roleInstance) => {
              if (!roleIds.includes(roleInstance.RoleId)) {
                roleIds.push(roleInstance.RoleId);
                let roleDataPoints = [];
                if (
                  typeof roleInstance.IoLocLocations === "object" &&
                  roleInstance.IoLocLocations !== 0
                ) {
                  roleInstance.IoLocLocations.forEach((location) => {
                    if (
                      location.Latitude !== 0 &&
                      location.Latitude !== 18 &&
                      location.Latitude !== -34.0130835 &&
                      location.Latitude !== -34.0130773
                    ) {
                      const dataPoint = new window.google.maps.LatLng(
                        location.Latitude,
                        location.Longitude
                      );
                      if (
                        location.Latitude == -34.0130835 ||
                        location.Latitude == -34.0130773
                      ) {
                        console.log("one of those two");
                      } else {
                        dataPoints.push(dataPoint);
                        roleDataPoints.push(dataPoint);
                      }
                    }
                  });
                }

                roleData = {
                  ...roleData,
                  [roleInstance.RoleId]: {
                    title: roleInstance.Role.Title,
                    roleDataPoints: roleDataPoints,
                    type: roleInstance.Role.Type,
                  },
                };
              } else {
                let newRoleDataObject = roleData[roleInstance.RoleId];

                delete roleData[roleInstance.RoleId];
                if (
                  typeof roleInstance.IoLocLocations === "object" &&
                  roleInstance.IoLocLocations !== 0
                ) {
                  roleInstance.IoLocLocations.forEach((location) => {
                    if (location.Latitude !== 0 && location.Latitude !== 18) {
                      const dataPoint = new window.google.maps.LatLng(
                        location.Latitude,
                        location.Longitude
                      );
                      dataPoints.push(dataPoint);
                      newRoleDataObject.roleDataPoints.push(dataPoint);
                    }
                  });
                }

                roleData = {
                  ...roleData,
                  [roleInstance.RoleId]: newRoleDataObject,
                };
              }

              if (roleInstance.Role.Type === "Patrol") {
                //console.log(roleInstance);
                patrolTime += this.getTimeDifferenceNumber(
                  roleInstance.timeStart,
                  roleInstance.DateTimeEnd
                );
                if (
                  typeof roleInstance.IoLocLocations === "object" &&
                  roleInstance.IoLocLocations.length !== 0
                ) {
                  roleInstance.IoLocLocations.forEach((location) => {
                    if (location.Latitude !== 0 && location.Latitude !== 18) {
                      const dataPoint = new window.google.maps.LatLng(
                        location.Latitude,
                        location.Longitude
                      );
                      dataPoints.push(dataPoint);
                      patrolDataPoints.push(dataPoint);
                    }
                  });
                }
              } else if (roleInstance.Role.Type === "Roam") {
                roamTime += this.getTimeDifferenceNumber(
                  roleInstance.timeStart,
                  roleInstance.DateTimeEnd
                );
                if (
                  typeof roleInstance.IoLocLocations === "object" &&
                  roleInstance.IoLocLocations.length !== 0
                ) {
                  roleInstance.IoLocLocations.forEach((location) => {
                    if (location.Latitude !== 0 && location.Latitude !== 18) {
                      const dataPoint = new window.google.maps.LatLng(
                        location.Latitude,
                        location.Longitude
                      );
                      dataPoints.push(dataPoint);
                      roamDataPoints.push(dataPoint);
                    }
                  });
                }
              } else if (roleInstance.Role.Type === "Station") {
                stationTime += this.getTimeDifferenceNumber(
                  roleInstance.timeStart,
                  roleInstance.DateTimeEnd
                );
                if (
                  typeof roleInstance.IoLocLocations === "object" &&
                  roleInstance.IoLocLocations.length !== 0
                ) {
                  roleInstance.IoLocLocations.forEach((location) => {
                    if (location.Latitude !== 0 && location.Latitude !== 18) {
                      const dataPoint = new window.google.maps.LatLng(
                        location.Latitude,
                        location.Longitude
                      );
                      dataPoints.push(dataPoint);
                      stationDataPoints.push(dataPoint);
                    }
                  });
                }
              }
            });

            if (
              typeof shiftGuard.TaskInstances === "object" &&
              shiftGuard.TaskInstances.length !== 0
            ) {
              shiftGuard.TaskInstances.forEach((taskInstance) => {
                taskInstance.IoLocLocations.forEach((location) => {
                  if (location.Latitude !== 0 && location.Latitude !== 18) {
                    const dataPoint = new window.google.maps.LatLng(
                      location.Latitude,
                      location.Longitude
                    );
                    dataPoints.push(dataPoint);
                  }
                });
              });
            }
            if (
              typeof shiftGuard.Breaks === "object" &&
              shiftGuard.Breaks.length !== 0
            ) {
              shiftGuard.Breaks.forEach((taskInstance) => {
                taskInstance.IoLocLocations.forEach((location) => {
                  if (location.Latitude !== 0 && location.Latitude !== 18) {
                    const dataPoint = new window.google.maps.LatLng(
                      location.Latitude,
                      location.Longitude
                    );
                    dataPoints.push(dataPoint);
                  }
                });
              });
            }

            return (
              <GuardOverview
                key={index}
                currentBuilding={shiftData.Building}
                shiftGuard={shiftGuard}
                dataPoints={dataPoints}
                roleData={roleData}
                roleIds={roleIds}
                floorOverlays={floorOverlays}
                patrolDataPoints={patrolDataPoints}
                roamDataPoints={roamDataPoints}
                stationDataPoints={stationDataPoints}
                smallList={smallList}
                firebase={firebase}
                patrolTime={patrolTime}
                roamTime={roamTime}
                stationTime={stationTime}
              ></GuardOverview>
            );
          })}
        </Box>
      </Box>
    );

    const patrolBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Run></Run>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="patrols"
            size="small"
            level="3"
            textAlign="center"
          >
            Patrols done
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>

        <Box
          direction="column"
          margin="small"
          align="center"
          justify="center"
          border={{ color: "black", size: "small" }}
        >
          <PatrolsTable shiftData={shiftData}></PatrolsTable>
        </Box>
      </Box>
    );

    const routeInstanceBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Tag></Tag>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="routes"
            size="small"
            level="3"
            textAlign="center"
          >
            Routes completed
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>

        <Box
          direction="row"
          margin="small"
          alignContent="center"
          justify="center"
          border={{ color: "black", size: "small" }}
        >
          <RouteInstanceTables shiftData={shiftData}></RouteInstanceTables>
        </Box>
      </Box>
    );

    const roamBlock = (
      <Box>
        <Box direction="row" align="center" justify="center">
          <Accessibility></Accessibility>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="roams"
            size="small"
            level="3"
            textAlign="center"
          >
            Roaming
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>

        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <RoamTable shiftData={shiftData}></RoamTable>
        </Box>
      </Box>
    );

    const stationBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Catalog></Catalog>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="stations"
            size="small"
            level="3"
            textAlign="center"
          >
            Stationed guards
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>

        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <StationView shiftData={shiftData}></StationView>
        </Box>
      </Box>
    );

    const incidentBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Alert></Alert>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="incidents"
            size="small"
            level="3"
            textAlign="center"
          >
            Incidents
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <IncidentsView
            firebase={firebase}
            shiftData={shiftData}
          ></IncidentsView>
        </Box>
      </Box>
    );

    const breaksBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Cafeteria></Cafeteria>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="breaks"
            size="small"
            level="3"
            textAlign="center"
          >
            Breaks
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <BreaksView shiftData={shiftData}></BreaksView>
        </Box>
      </Box>
    );

    const taskOverviewBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Cafeteria></Cafeteria>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="tasks_overview"
            size="small"
            level="3"
            textAlign="center"
          >
            Tasks Overview
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <TaskOverViewTable shiftData={shiftData}></TaskOverViewTable>
        </Box>
      </Box>
    );

    const delayedTasksBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Cafeteria></Cafeteria>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="delayed_tasks"
            size="small"
            level="3"
            textAlign="center"
          >
            Delayed Tasks
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <DelayedTaskTable shiftData={shiftData}></DelayedTaskTable>
        </Box>
      </Box>
    );

    const tasksBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Schedules></Schedules>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            size="small"
            level="3"
            textAlign="center"
            id="tasks"
          >
            Tasks
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <TaskDetail
            firebase={firebase}
            shiftData={shiftData}
            floorOverlays={floorOverlays}
            currentBuilding={shiftData.Building}
          ></TaskDetail>
        </Box>
      </Box>
    );

    const logbookBlock = (
      <Box>
        <Box align="center" justify="center" direction="row">
          <Schedules></Schedules>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            size="small"
            level="3"
            textAlign="center"
            id="logbooks"
          >
            Logbooks
          </Heading>
          <a href="#home">
            <Home></Home>
          </a>
        </Box>
        <Box
          justify="center"
          direction="row"
          margin="small"
          align="center"
          border={{ color: "black", size: "small" }}
        >
          <LogbookTable
            firebase={firebase}
            shiftData={shiftData}
            currentBuilding={shiftData.Building}
          ></LogbookTable>
        </Box>
      </Box>
    );

    tabBlock = (
      <Box>
        <Box align="center" justify="center">
          <Heading size="small">{shiftData.Description}</Heading>
          <Heading size="small" level="3" textAlign="center">
            {getPrettyDateString(DateTimeStart)} to{" "}
            {getPrettyDateString(DateTimeEnd)}
          </Heading>
        </Box>

        <Box align="center" justify="center" direction="row">
          <Home></Home>
          <Heading
            margin={{ right: "medium", left: "medium" }}
            id="home"
            size="small"
            level="3"
            textAlign="center"
          >
            Contents
          </Heading>
        </Box>
        <Box
          direction="column"
          margin="small"
          align="center"
          justify="center"
          border={{ color: "black", size: "small" }}
        >
          <a href="#timeline">Timeline</a>
          <a href="#overviews">Guard Overviews</a>
          <a href="#patrols">Patrols</a>
          <a href="#routes">Routes</a>
          <a href="#roams">Roams</a>
          <a href="#stations">Stations</a>
          <a href="#incidents">Incidents</a>
          <a href="#breaks">Breaks</a>
          <a href="#tasks_overview">Tasks Overview</a>
          <a href="#delayed_tasks">Delayed Tasks</a>
          <a href="#tasks">Tasks</a>
          <a href="#logbooks">Logbooks</a>
        </Box>
        {timelineBlock}
        {overViewBlock}
        {patrolBlock}
        {routeInstanceBlock}
        {roamBlock}
        {stationBlock}
        {incidentBlock}
        {breaksBlock}
        {taskOverviewBlock}
        {delayedTasksBlock}
        {tasksBlock}
        {logbookBlock}
      </Box>
    );

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////END OF PARTS OF REPORT/////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////START OF PARTS OF RETURN FUNCTION//////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
      <Grommet theme={theme}>
        <MainContainer>
          <Box
            direction="row"
            alignSelf="center"
            alignContent="center"
            align="center"
            pad="small"
            background="white"
            gap="small"
          >
            {tabBlock}
          </Box>
        </MainContainer>
      </Grommet>
    );

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////END OF PARTS OF RETURN FUNCTION////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
  }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END MAIN COMPONENT DEFINITION///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START OF HELPER FUNCTION////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

const ShiftQuery = (props) => {
  console.log(props);

  const variables = {
    id: props.shiftId,
    exclId: 1, //excludes Ross
    exclId2: props.lobi, //excludes lobi by default unless http://localhost:3000/?1?4937?lobi passed in
    //date: props.shiftStartDate,
  };
  return (
    <Query query={SHIFT_QUERY} variables={variables}>
      {({ loading, error, data, client }) => {
        if (loading) {
          return <div>loading...</div>;
        }
        if (error) {
          console.log("Output: : error", error);
          return <div>Error</div>;
        }

        return (
          <Report
            client={client}
            shiftId={props.shiftId}
            shiftData={data.Shift[0]}
          ></Report>
        );
      }}
    </Query>
  );
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF HELPER FUNCTION//////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

export default ShiftQuery;
